import { render, staticRenderFns } from "./InputCollapseGroup.vue?vue&type=template&id=fdc58ba6&scoped=true"
import script from "./InputCollapseGroup.vue?vue&type=script&lang=js"
export * from "./InputCollapseGroup.vue?vue&type=script&lang=js"
import style0 from "./InputCollapseGroup.vue?vue&type=style&index=0&id=fdc58ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc58ba6",
  null
  
)

export default component.exports